import advertising from 'rp-advertising';

const setTargeting = (targetingStr) => {
    const UPDATE_TARGETING = 'updateTargeting';

    if (targetingStr) {
        advertising({
            targeting: [targetingStr],
            targetingEvent: UPDATE_TARGETING,
        });
    } else {
        advertising();
    }
};


const initAds = () => {
    const paddyPowerDomain = 'paddypower.com';
    const { referrer } = document;

    if (referrer.includes(paddyPowerDomain)) {
        setTargeting('paddypower');
    } else {
        setTargeting();
    }
};

export default initAds;



// WEBPACK FOOTER //
// ./src/js/initAds.js